import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-shared-copy-snackbar',
  templateUrl: './shared-copy-snackbar.component.html',
  styleUrls: ['./shared-copy-snackbar.component.scss'],
})
export class SharedCopySnackbarComponent {
  message: string;
  icon: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    this.message = data.message;
    this.icon = data.icon;
  }
}
